import { useTutorLegalStore } from '@stores/tutor-legal'

import { useTutorBillingApi } from '@api/tutors/billing.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const tutorId = to.params.id as string

  // Wipe the previous tutor's data so it can never be shown (or saved) under
  // another tutor while the fresh GET is in flight or after it fails.
  useTutorLegalStore().reset()

  void useTutorBillingApi({ tutorId })
})
